import Constants from '@/Constants';
import { AddToListRequest } from '@/models/List';
import http from '@/services/HttpService';
import { toast } from 'react-toastify';
import { call, put } from 'redux-saga/effects';
import { PayloadAction } from 'typesafe-actions';
import { store } from '../index';
import { publishListSuccess } from '../list/action';
import {
    addItemsToListFailure,
    addItemsToListSuccess,
    deleteItemFromListFailure,
    deleteItemFromListSuccess,
    getListItemsFailure,
    getListItemsSuccess
} from './action';
import { ListItemsTypes } from './types';

export function* addItemsToList(
    action: PayloadAction<ListItemsTypes.ADD_TO_LIST_REQUEST, { payload: AddToListRequest[]; willPublish: boolean; listId: number; history: any }>,
) {
    const {
        locale: {
            data: { toastMessages },
        },
    } = store.getState();

    try {
        if (action.payload.payload.length > 0) {
            yield call(http.post, `${Constants.LESSONS_URI}/batch-create`, action.payload.payload);
            yield put(addItemsToListSuccess());
            if (action.payload.payload.length === 1) {
                toast.success(toastMessages.ADD_ITEM_TO_LIST_SUCCESS);
            } else {
                toast.success(toastMessages.ADD_ITEMS_TO_LIST_SUCCESS);
            }
        }

        if (action.payload.willPublish) {
            yield call(http.post, `${Constants.LMS_COURSES_URI}/${action.payload.listId}/publish`);
            yield put(publishListSuccess(action.payload.listId));
            toast.success(toastMessages.LIST_PUBLISHED_SUCCESS);
            action.payload.history.push('/contents/playlist/lists');
        }
    } catch (err) {
        toast.error(toastMessages.ADD_ITEMS_TO_LIST_ERROR);
        yield put(addItemsToListFailure(err));
    }
}

export function* deleteItemFromList(
    action: PayloadAction<ListItemsTypes.DELETE_FROM_LIST_REQUEST, { lessonId: number; listId: number | undefined }>,
) {
    const {
        locale: {
            data: { toastMessages },
        },
    } = store.getState();

    try {
        yield call(http.delete, `${Constants.LESSONS_URI}/${action.payload.lessonId}`);

        yield put(deleteItemFromListSuccess(action.payload.lessonId));

        toast.success(toastMessages.REMOVE_ITEM_FROM_LIST_SUCCESS);
    } catch (err) {
        toast.error(toastMessages.REMOVE_ITEM_FROM_LIST_ERROR);
        yield put(deleteItemFromListFailure(err));
    }
}

export function* getListItems(action: PayloadAction<ListItemsTypes.GET_LIST_ITEMS_REQUEST, number>) {
    try {
        const { data } = yield call(http.get, `${Constants.LMS_COURSES_URI}/${action.payload}/lessons`);
        yield put(getListItemsSuccess(data));
    } catch (err) {
        yield put(getListItemsFailure(err));
    }
}
